import styled from "styled-components";
import ArrowIcon from "../../assets/icons/arrow-down.svg";

export const Container = styled.div`
  display: flex;
  border-radius: 12px;
  gap: 17px;
  align-items: center;
  padding: 0px;
  /* min-height: 56px; */

  .custom-dropdown-button {
    & .show {
      background-color: #161a1d !important;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }
    & button {
      width: fit-content;
      background-color: #161a1d !important;
      padding: 6px 16px;
      border-radius: 12px;
      color: #ffffff;
      font-size: 16px;
      appearance: none;
      border: 1px solid rgba(255, 255, 255, 0.2);
      cursor: pointer;
      display: flex;
      gap: 15px;
      align-items: center;
      justify-content: space-between;
      width: auto;
      height: 44px;

      :hover {
        background-color: rgb(26, 30, 32) !important;
      }
    }
    & .btn:hover {
      color: #fff;
      background-color: #161a1d;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }
  }
  .dropdown-toggle::after {
    content: "";
    /* background-image: url("../../assets/icons/arrow-down.svg"); */
    background-repeat: no-repeat;
    background-position: center center;
    display: inline-block;
    border: none;
    width: 15px;
    height: 15px;
  }

  .custom-dropdown-button:hover,
  .custom-dropdown-button:focus,
  .custom-dropdown-button:active {
    background-color: transparent;
    color: white;
  }

  .custom-dropdown-button .dropdown-menu {
    background-color: #161a1d;
    border-radius: 12px;
    font-size: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 100%;
    margin-top: 10px;
  }

  .custom-dropdown-button .dropdown-item {
    padding: 2px 10px 2px 5px;
    cursor: pointer;
  }

  .custom-dropdown-button .dropdown-item:hover {
    background-color: #424969;
  }
  .custom-form-control-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #ffffff;
    font-size: 14px;
    margin-left: 7px;
  }
  .custom-form-control-label-title {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const ImageWrapper = styled.div`
  width: 32px;
  height: 32px;
  img {
    width: 100%;
    height: 100%;
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
  height: 100%;
  align-items: center;
  display: flex;
`;

export const CustomSelect = styled.select`
  width: fit-content;
  padding: 6px 16px;
  border-radius: 8px;
  background-color: #4e5574;
  color: #ffffff;
  font-size: 14px;
  appearance: none;
  border: 1px solid #737da8;
  padding-right: 40px;
  cursor: pointer;
  padding-left: 70px;

  background-image: url(${ArrowIcon});
  background-repeat: no-repeat;
  background-position: right 0px center;
  background-size: 28px;

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
    background-color:rgb(84, 86, 92);
  `}

  &:focus {
    outline: none;
    background-color: #353a52;
  }

  font-size: 16px;
  font-weight: 400;
  line-height: 18px;

  & option {
    margin-left: -70px;
  }
`;

export const Option = styled.option`
  background-color: #4e5574;
  color: #ffffff;
`;
